dealershipModule.directive('profitSetting', function factory() {
    return{
        templateUrl: 'app/modules/dealership/directives/profit-setting-directive.html',
        replace: true,
        restrict: 'E',
        controller: 'ProfitSettingsController',
        scope:  {
            product: "=product",
            promiseSave: "="
        }
    };
});